




























import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue'
import PageNames from '@/router/PageNames';
import NoteCategories from '@/components/NoteCategories/NoteCategories.vue';

@Component({
	name: 'AgencyNoteCategorySettings',
  	components: { NoteCategories, Alert }
})
export default class extends GiganautVue {

	beforeMount() {
		AgencySettingsModule.getNoteCategories();
  	}

	navigateToAgencySettings() {
		this.$router.push({ name: PageNames.AgencySettings });
	}

  	get loading() {
		return AgencySettingsModule.loadingNoteCategories;
  	}
}
